<script lang="ts">
  import type { ClassValue } from "svelte/elements";
  import type { FacetValueInput, FacetValueInputOptions } from "./type.ts";
  import inputDefault from "../facet-value/InputDefaultAction.ts";
  import { removeStatusIf, featureTrackingAttributes } from "../tracking";

  interface Props extends FacetValueInput, FacetValueInputOptions {
    id?: string;
    class?: ClassValue;
    selectedValues?: string;
    excludeFromTracking?: boolean;
    isValid?: boolean;
  }

  let {
    name,
    value,
    checked,
    popular,
    "aria-label": ariaLabel,
    featureTracking = $bindable(),
    id = `${name}_${featureTracking?.id}`,
    selectedValues = $bindable(),
    excludeFromTracking = $bindable(false),
    isValid = $bindable(),
    ...rest
  }: Props = $props();

  /*                     */
  const tracking = $derived(removeStatusIf((!checked && !popular) || excludeFromTracking, featureTracking));

  /*                            */
  ariaLabel ||= rest.forceAriaLabel ? rest.title : undefined;

  function onchange({ currentTarget }: Event & { currentTarget: HTMLInputElement }) {
    selectedValues = currentTarget.value;
  }

  const type = featureTracking?.method || "radio_button";
</script>

<input
  {id}
  class={["hc_facetValueInput", { js_hc_tValue: !excludeFromTracking }, rest.class]}
  {name}
  type="radio"
  {value}
  {checked}
  aria-label={ariaLabel}
  data-ts-feature-filter-method={type}
  data-valid={isValid}
  {...featureTrackingAttributes(tracking)}
  use:inputDefault={true}
  {onchange}
/>
